import { Department, LevelType } from "./dict";

export interface BudgetLevel {
  level_number: number;
  budget_type: string;
}

export interface BudgetTableItem {
  article: string;
  code_it_id: number;
  contragent_id: number;
  vat: boolean;
  quantity?: number;
  mon_1?: number;
  mon_2?: number;
  mon_3?: number;
  mon_4?: number;
  mon_5?: number;
  mon_6?: number;
  mon_7?: number;
  mon_8?: number;
  mon_9?: number;
  mon_10?: number;
  mon_11?: number;
  mon_12?: number;
  row_total?: number;
  budget_line_rows: LevelType[];
}

export const emptyBudgetRow: BudgetTableItem = {
  article: "",
  code_it_id: 0,
  contragent_id: 0,
  vat: false,
  budget_line_rows: [],
};

export interface BudgetRequest {
  budget_request_id: number;
  year: number;
  department: string;
  company: string;
  budget_type: string;
  creator_name: string;
  request_date: string;
  status: boolean;
  budget_request_details: BudgetTableItem[];
}

export interface BudgetRequestResponse {
  total_count: number;
  budget_requests: BudgetRequest[];
}

export const DefaultBudgetRequestResponse: BudgetRequestResponse = {
  total_count: 0,
  budget_requests: [],
};

export interface BudgetRequestHistory {
  id: number;
  user_id: number;
  budget_report_template_id: number;
  budget_report_template_name: string;
  company_ids: number[];
  companies: [
    {
      company_id: number;
      company: string;
      status: boolean;
    }
  ];
  department_ids: number[];
  departments: Department[];
  year: number;
  payload: {
    [key: string]: any;
  };
  response: {
    [key: string]: any;
  };
  created_at: string;
  updated_at: string;
}

export interface BudgetRequestHistoryResponse {
  page: number;
  page_size: number;
  total_pages: number;
  total_items: number;
  items: BudgetRequestHistory[];
}

export interface LevelGroup {
  levels: { [key: number]: number[] };
  parent_budget_type_id: number;
}

export interface ReportTemplate {
  budget_report_template_id: number;
  template_name: string;
  status: boolean;
  json_description: {
    year: number;
    hash_pw: string;
    groupings: LevelGroup[];
    structure: "hierarchical" | "tabular";
    add_forecast: boolean;
    company_id: number[];
    need_columns: string[];
    additional_formulas: number[];
    need_formulas: string[];
    department_id: number;
    generate_excel: boolean;
  };
}

export interface ArticlesResponse {
  articles: string[];
  total_count: number;
  q: string;
}

export interface BudgetSummaryRow {
  budget_amount: number;
  budget_level_id_path: string;
  budget_level_name_path: string;
  current_budget_level: number;
  current_diff: number;
  current_utilization_rate: number;
  depth: number;
  display_name: string;
  expected_diff: number;
  expected_utilization_rate: number;
  indent_level: number;
  is_leaf: boolean;
  is_total: boolean;
  payment_completed: number;
  payment_pending: number;
  record_count: number;
  sort_key: string;
  sort_path: string;
  autocorrection_total: number;
}

export interface BudgetSummaryResponse {
  header: {
    [key: string]: string;
  };
  rows: BudgetSummaryRow[];
}

export const DefaultBudgetSummaryResponse = {
  header: {},
  rows: [],
};
